<template>
  <div class="step-wizard">
    <step-line
      :steps="steps"
      :active="active"
      :clickable="canGoBack"
      @select="goTo"
    ></step-line>

    <div class="step-content">
      <slot :name="currentStep.name" :step="currentStep"></slot>
    </div>
  </div>
</template>

<script>
import StepLine from "@/components/ecologist/dataEntryNew/stepLine";

/*
  Этапы без кнопок «Далее» и «Назад»: вперёд переводят действия на самих этапах,
  назад - нажатие на пройденный этап в линии этапов
*/
export default {
  name: "stepWizard",
  components: { StepLine },
  model: { prop: "value", event: "input" },
  props: {
    // [{ name, title, description? }], name - имя слота этапа
    steps: { type: Array, required: true },
    value: { type: Number, default: 0 },
    canGoBack: { type: Boolean, default: true },
  },
  data() {
    return {
      active: this.value,
    };
  },

  computed: {
    currentStep() {
      return this.steps[this.active] || {};
    },
  },

  watch: {
    value(val) {
      this.active = val;
    },
    steps() {
      if (this.active > this.steps.length - 1)
        this.setActive(Math.max(0, this.steps.length - 1));
    },
  },

  methods: {
    setActive(index) {
      this.active = index;
      this.$emit("input", index);
    },

    // Вернуться к пройденному этапу
    goTo(index) {
      if (this.canGoBack && index < this.active) this.setActive(index);
    },
  },
};
</script>

<style scoped>
.step-wizard {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.step-content {
  flex: 1;
  min-height: 0;
  overflow: auto;
}
</style>
